<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper :options="swiperOption"
                  ref="mySwiper">
            <swiper-slide v-for="(item, index) in topRotation"
                          :key="index">
              <img :src="item.resUrl"
                   style="border-radius: 20px 0px 0px 0px; cursor: pointer;"
                   width="930"
                   height="380"
                   @click="Towindowurl(item.url)" />
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
          </swiper>
        </div>
        <div style="cursor: pointer;"
             class="bannerright"
             @click="Englishentrance">
          <img src="/image/index/index4tuceng.png"
               class="shan" />
          <img v-for="(item, index) in righttopRotation.slice(0, 1)"
               :key="index + '1'"
               :src="item.resUrl"
               width="220"
               height="280"
               style="position: relative;" />
        </div>
      </div>
    </div>
    <div class="GL_WrapRectangle marginTop10">
      <div class="GL_rectangle"
           v-for="(item, index) in columnNavList"
           :key="index + '1'"
           :class="{ GL_rectangleActive: menuTag == index }"
           @click="columnNavclick(item, index)">
        {{ item.name }}
      </div>
    </div>
    <div class="border_bottom_18 EC_width marginTop10"></div>
    <div class="main display_between_nocenter EC_width">
      <div class="mainLeft">
        <ul class="menuLitagWrap">
          <li class="menulitag"
              :class="{ menulitagActive: listmenuTagindex == 0 }"
              @click="listmenuTagindex = 0">
            <a href="http://zgqkyxauthor.manuscriptcloud.com/login"
               target="_blank">
              <img src="/image/index/menuli1.png"
                   class="normalimg" />
              <img src="/image/index/menuli_h1.png"
                   class="hoverimg" />
              <span class="marginTop10">在线投稿入口</span>
            </a>
          </li>
          <li class="menulitag"
              :class="{ menulitagActive: listmenuTagindex == 1 }"
              @click="listmenuTagindex = 1">
            <a href="http://zgqkyxauthor.manuscriptcloud.com/login"
               target="_blank">
              <img src="/image/index/menuli2.png"
                   class="normalimg" />
              <img src="/image/index/menuli_h2.png"
                   class="hoverimg" />
              <span class="marginTop10">专家审稿入口</span>
            </a>
          </li>
          <li class="menulitag"
              :class="{ menulitagActive: listmenuTagindex == 2 }"
              @click="listmenuTagindex = 2">
            <a href="javascript:;"
               @click="onMore(columnLeftList[0].id, columnLeftList[0].name)">
              <img src="/image/index/menuli3.png"
                   class="normalimg" />
              <img src="/image/index/menuli_h3.png"
                   class="hoverimg" />
              <span class="marginTop10">作者服务中心</span>
            </a>
          </li>
          <li class="menulitag"
              :class="{ menulitagActive: listmenuTagindex == 3 }"
              @click="listmenuTagindex = 3">
            <a :href="httphelper.IsDebugGP519() + '/home/specialRecomme?id=167'">
              <img src="/image/index/menuli4.png"
                   class="normalimg" />
              <img src="/image/index/menuli_h4.png"
                   class="hoverimg" />
              <span class="marginTop10">专家服务中心</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="mainCenter flex1">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="tagTitleMulLine "
                  :class="{ tagTitleActive: focusTagindex == 0 }"
                  @click="tagDatafocus(0, 64)">主编<br />推荐</span>
            <span class="tagTitleMulLine"
                  :class="{ tagTitleActive: focusTagindex == 1 }"
                  @click="tagDatafocus(1, 65)">域出<br />版</span>
            <span class="tagTitleMulLine"
                  :class="{ tagTitleActive: focusTagindex == 2 }"
                  @click="tagDatafocus(2, 66)">优先<br />出版</span>
            <span class="tagTitleMulLine"
                  :class="{ tagTitleActive: focusTagindex == 3 }"
                  @click="tagDatafocus(3, 67)">预出<br />版</span>
            <span class="tagTitleMulLine"
                  :class="{ tagTitleActive: focusTagindex == 4 }"
                  @click="tagDatafocus(4, 68)">高引<br />文章</span>
            <span class="tagTitleMulLine"
                  :class="{ tagTitleActive: focusTagindex == 5 }"
                  @click="tagDatafocus(5, 69)">电子<br />期刊</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(focusTagindex == 0 ? 64 : focusTagindex == 1 ? 65 : focusTagindex == 2 ? 66 : focusTagindex == 3 ? 67 : focusTagindex == 4 ? 68 : 69,
              focusTagindex == 0 ? '当前焦点' : focusTagindex == 1 ? '域出版' : focusTagindex == 2 ? '优先出版' : focusTagindex == 3 ? '网络出版' : focusTagindex == 4 ? '高引文章' : '电子期刊')">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>

        <div v-for="(item, index) in newlist"
             :key="index">
          <div v-if="item.cid == comlnabto">
            <div class="gl_listWrapBar_nopad controlShow"
                 style="margin: 20px 0;"
                 @click="clkNews(item)">
              <div class="gl_imgList setShow">
                <img :src="item.slideShow" />
              </div>
              <a href="javascript:;"
                 class="gl_listItem display_column">
                <div class="gl_listItemTitle fontBold setShow">
                  {{ item.title }}
                </div>
                <div class="gl_listItemTitle disShow"
                     style="line-height:0px;">
                  {{ ellipsis(item.title, 38) }}
                </div>
                <div class="display_between marginTop10 setShow">
                  <div>
                    <span></span>
                  </div>
                  <div class="gl_inforshow marginTop20">
                    <span class="marginRight20">{{ formatTime(item.publishtime, 'YYYY/MM/DD') }}</span>
                    <span v-if="item.clickVolume > 0">
                      <img src="/image/index/chakan.png" />
                      {{ item.clickVolume }}
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">杂志公告</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(162, '杂志公告')">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="gl_listWrapBar_nopad border_bottom_18 marginTop20"
             v-for="(item, index) in noticeList.slice(0, 4)"
             :key="index + '1'"
             @click="clkNews(item)">
          <div class="gl_imgList">
            <div class="custom_img">
              <span class="daynumber">{{ item.time }}</span>
              <span class="datenumber">{{ item.time2 }}</span>
            </div>
          </div>
          <a href="javascript:;"
             class="gl_listItem display_center_ud">
            <div class="gl_listItemTitle">
              {{ ellipsis(item.title, 28) }}
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="main display_between_nocenter EC_width">
      <div class="marginRight50 flex1">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">当月目次</span>
            <span class="grayColor marginLeft20">全科医学杂志当期和历史期次查阅</span>
          </div>
          <div class="gl_tb_right">
            <a href="/journal/magazinesectionlist"
               target="_blank"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="display_flex">
          <div class="mainLeft marginTop20">
            <ul class="pubL_menu ">
              <li :class="{ pubL_menu_active: yearTagindex == index }"
                  @click="tagDatayear(index, item)"
                  v-for="(item, index) in treedata"
                  :key="index + '1'">
                <a href="javascript:;">{{ item.label }}年</a>
                <div class="arrtig"></div>
              </li>
            </ul>
          </div>
          <div class="flex1 marginLeft50">
            <div class="number">
              <table>
                <tr v-for="(item, index) in periods"
                    :key="index + '1'">
                  <td :class="{ activeTd: periodsTagindex == index + '1' + index2 }"
                      @click="tagDataperiods(index, index2, qitem)"
                      v-for="(qitem, index2) in item"
                      :key="index2 + '2'">
                    <a href="javascript:void(0);">{{ qitem.label }}期</a>
                  </td>
                </tr>
              </table>
            </div>
            <div class="ortextWrap"
                 id="gl_title">
              <div class="gl_title_vertical_line_O mous"
                   :class="{ fontBold: item.isbold }"
                   v-for="(item, index) in newArticleList"
                   :key="index + '1'"
                   @click="tojourdetail(item)">
                {{ textFormat(item.biaoTi_CN) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">征稿</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(73, '杂志征稿')">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="gl_listWrapBar"
             v-for="(item, index) in journNoticeList"
             :key="index + '1'"
             @click="clkNews(item)">
          <a href="javascript:;"
             class="gl_listItem">
            <div class="gl_listItemTitle gl_ltStyle_line">
              {{ item.title }}
            </div>
            <div class="display_between marginTop10">
              <div class="gl_inforshow">
                <span class="marginRight20">{{ formatTime(item.publishtime, 'YYYY/MM/DD') }}</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <div class="main main display_between_nocenter EC_width">
      <div class="mainLeft"
           v-for="(item, index) in rightbottomRotation"
           :key="index"
           @click="Towindowurl(item.url)">
        <img class="imgtran"
             :src="item.resUrl"
             width="100%" />
      </div>
      <div class="mainCenter flex1">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">国际全科医学杂志</span>
          </div>
          <div class="gl_tb_right">
          </div>
        </div>
        <div class="positionBtn_swiper">
          <swiper :options="swiperOption1"
                  ref="mySwiper2">
            <swiper-slide v-for="(item, index) in bottomRotation"
                          :key="index"
                          style="width:210px ;margin-left:15px">
              <img :src="item.resUrl"
                   width="143"
                   height="185"
                   @click="Towindowurl(item.url)" />
            </swiper-slide>
          </swiper>
          <div class="prevbutton">&lt;</div>
          <div class="nextbutton">&gt;</div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar marginBottom40">
          <div class="gl_tb_left">
            <span class="normaltitle">官方微信</span>
          </div>
        </div>
        <div class="display_between">
          <div class="text_center">
            <img src="/image/index/lefter.png" />
            <p class="marginTop20">《中国全科医学》杂志</p>
          </div>
          <div class="text_center">
            <img src="/image/index/rightEr.png" />
            <p class="marginTop20">《中国全科医学》学术平台</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';
import format from '@/assets/unit/unit.js';
export default {
  name: 'magazine',
  data () {
    return {
      apiData: {
        focus: {},
        notice: {},
        contents: {
          data: {
            years: {},
            periods: {},
            news: {}
          }
        },
        draft: {},
        magazine: {}
      },
      // 期数
      periods: [],
      // 菜单切换
      menuTag: 0,
      //左侧菜单切换
      listmenuTagindex: 0,
      // 主编推荐切换
      focusTagindex: 0,
      // 年份切换
      yearTagindex: 0,
      // 期数切换
      periodsTagindex: '010',
      swiperOption: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive'
        },
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        }
      },
      swiperOption1: {
        freeMode: true,
        slidesPerView: 'auto',
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton'
        }
      },
      /**tianlianpei */
      // 栏目导航左
      coluletab: 0,
      // 栏目下上导航
      comlnabto: 64, //默认显示主编推荐
      comlnabtoname: '主编推荐',
      // 期刊浏览年期列表
      journboewissuedata: [
        {
          isShow: true,
          year: '2020',
          issue: [
            {
              title: '1'
            }
          ]
        }
      ],
      // 期刊右侧征稿
      journNoticeList: [],
      columnNavList: [
        {
          name: '杂志简介',
          url: '/journal/inforDetails?id=255&column_Type=72'
        },
        {
          name: '入选数据库',
          url: '/journal/Inforlist?pid=36&cid=177&title=入选数据库'
        },
        {
          name: '绿色通道',
          url: '/journal/inforDetails?id=1001&column_Type=72'
        },
        {
          name: '期刊订阅',
          url: '/journal/inforDetails?id=816&column_Type=72'
        },
        { name: '论文检索', url: '/home/searchPage?tagIndexmuber=ShLiteList' },
        { name: 'Journal', url: 'https://fmch.gp519.com/e-journal/enhome' }
      ],
      columncentreList: [],
      columnLeftList: [],
      columnLefTtTList: [
        {
          name: '在线投稿入口',
          url: 'http://zgqkyxauthor.manuscriptcloud.com/login'
        },
        {
          name: '专家审稿入口',
          url: 'http://zgqkyxauthor.manuscriptcloud.com/login'
        }
      ], //在线审稿，专家审稿
      columnNoticeList: [],
      newlist: [],
      noticeList: [], //杂志广告
      treedata: [], //年卷树结构数据
      newArticleList: [], //最新数据
      topRotation: [],
      bottomRotation: [],
      righttopRotation: [],
      rightbottomRotation: []
    };
  },
  created () {
    this.GetRotationInfo();
    this.GetColumsInfoAllList();
    this.GetArticleBrowseInfo();
  },
  methods: {
    Englishentrance () {
      window.open('/e-journal', '_blank');
    },
    tagDatafocus (index, id) {
      this.focusTagindex = index;
      this.comlnabto = id;
    },
    tagDataperiods (index, index2, item) {
      // 当月目次
      // 期数取数据

      var gl_title = document.getElementById('gl_title');
      gl_title.scrollTop = 0;
      this.periodsTagindex = index + '1' + index2;
      this.GetArticleInfoPageList(item.plabel, item.label);
    },
    tagDatayear (index, item) {
      // 当月目次
      this.periodsTagindex = '010';
      this.yearTagindex = index;
      this.periods = [];
      this.periods = this.treedata.filter(function (item1) {
        return item1.label == item.label;
      })[0].children;
      this.periods = lodash.chunk(this.periods, 12);
      this.GetArticleInfoPageList(item.label, '1');
    },
    /**tianlianpei */
    //获取轮播数据
    GetRotationInfo () {
      let _this = this;
      let arr = [10, 11, 15, 16]; //分别代表杂志专区轮播，底部，右上，右下
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 10) {
                _this.topRotation = res.data.data || null;
              }
              if (arr[i] == 11) {
                _this.bottomRotation = res.data.data || null;
              }
              if (arr[i] == 15) {
                _this.righttopRotation = res.data.data || null;
              }
              if (arr[i] == 16) {
                _this.rightbottomRotation = res.data.data || null;
              }
            }
          });
      }
    },
    /**获取轮播数据 */
    columnNavclick (info, index) {
      this.menuTag = index;
      window.open(info.url);
    },
    /**获取栏目名称 */
    GetColumsInfoAllList () {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 1,
          isCHorEN: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            let data = res.data.data.sort(function (a, b) {
              return a.sort - b.sort;
            });
            data.forEach(item => {
              if (item.id >= 64 && item.id <= 69) {
                _this.columncentreList.push(item);
              }
              if (item.id == 70 || item.id == 71) {
                _this.columnLeftList.push(item);
              }
              if (item.id == 162) {
                //杂志公告
                _this.columnNoticeList.push(item);
              }
            });
            //获取内容数据
            _this.GetGpSiteNewInfoPageList();
          }
        });
    },
    /**获取首页中部新闻信息 */
    GetGpSiteNewInfoPageList () {
      let _this = this;
      let arrcolumntop = _this.columncentreList;
      for (let i = 0; i < arrcolumntop.length; i++) {
        _this.httphelper
          .post('/api/NewApi/GetGpSiteNewInfoPageList', {
            keyword: '',
            id: 0,
            parentID: 0,
            column_Type: arrcolumntop[i].id,
            pageIndex: 0,
            pageSize: 12
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.gpSiteNewInfoViewsViews != null && res.data.data.gpSiteNewInfoViewsViews.length > 0) {
                res.data.data.gpSiteNewInfoViewsViews.forEach(item => {
                  _this.newlist.push(item);
                });
              }
            }
          });
      }
      let arr = [73, 162];
      for (let i = 0; i < arr.length; i++) {
        //公告列表
        _this.httphelper
          .post('/api/NewApi/GetGpSiteNewInfoPageList', {
            keyword: '',
            id: 0,
            parentID: 0,
            column_Type: arr[i],
            pageIndex: 0,
            pageSize: arr[i] == 162 ? 4 : 5
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.gpSiteNewInfoViewsViews != null && res.data.data.gpSiteNewInfoViewsViews.length > 0) {
                res.data.data.gpSiteNewInfoViewsViews.forEach(item => {
                  if (item.cid == 162) {
                    _this.noticeList.push({
                      id: item.id,
                      cid: item.cid,
                      address: item.address,
                      title: item.title,
                      time2: item.publishtime.substr(0, 7),
                      time: item.publishtime.substr(8, 2)
                    });
                  } else if (item.cid == 73) {
                    _this.journNoticeList.push(item);
                  }
                });
              }
            }
          });
      }
    },
    /**新闻的点击事件 */
    clkNews (info) {
      let urlstr = info.address;
      let param = urlstr.substr(urlstr.indexOf('?'), urlstr.length - urlstr.indexOf('?'));
      if (urlstr.search('magazine/magazinejournal/magazinejournaldetail') > -1) {
        const { href } = this.$router.resolve({
          path: 'magazine/magazinejournal/magazinejournaldetail' + param
        });
        window.open(href, '_blank');
      } else {
        //如果外连接存在，跳转外链，否则跳转详情
        if (Object.keys(info.address).length == 0) {
          const { href } = this.$router.resolve({
            path: '/journal/inforDetails?',
            query: {
              id: info.id,
              column_Type: info.cid
            }
          });
          window.open(href, '_blank');
        } else {
          window.open(info.address);
        }
      }
    },
    /**获取期刊浏览数据 */
    GetArticleBrowseInfo () {
      let _this = this;
      _this.httphelper.get('/api/ArticleApi/GetArticleInfoAnnualPageList').then(res => {
        if (res.code == 200) {
          //年卷树结构数据
          _this.treedata = res.data.articleSelectTree || null;
          if (_this.treedata != null) {
            _this.tagDatayear(0, _this.treedata[0]);
          }
          //最新一期数据
          _this.newArticleList = res.data.gpSiteArticleInfoViews || null;
        }
      });
    },
    /**绑定点击当前年期的数据 */
    GetArticleInfoPageList (year, period) {
      let _this = this;
      this.httphelper
        .post('/api/ArticleApi/GetArticleInfoPageList', {
          year: year,
          period: period,
          id: 0,
          keywords: '',
          recommendNumber: 0
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.newArticleList = res.data.data.gpSiteArticleInfoViews || null;
          }
        });
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /**文献跳转详情 */
    tojourdetail (item) {
      var param = { nian: item.nian, qi: item.qi };
      localStorage.setItem('magazinejournal_param_' + item.nian, JSON.stringify(param));
      const { href } = this.$router.resolve({
        path: '/journal/magazinejournal/magazinejournaldetail',
        query: {
          nian: item.nian,
          qi: item.qi,
          id: item.id
        }
      });
      window.open(href, '_blank');
    },
    /**资讯更多 */
    onMore (cid, conetntitle) {
      this.$router.push({
        path: '/journal/Inforlist',
        query: {
          pid: 36,
          title: conetntitle,
          cid: cid
        }
      });
    },
    /** 轮播、广告图跳转外链 */
    Towindowurl (url) {
      if (url != null && url != '') window.open(url);
    },
    textFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '');
    }
  }
};
</script>

<style scoped>
.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
}

/* 上部banner */

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 930px;
    height: 380px;
    background: #005660;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 20px 0px 0px 0px;
}

.bannerright {
    width: 299px;
    height: 380px;
    background: #d9cfc8;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.06);
    border-radius: 0px 0px 20px 0px;
    padding: 50px 40px;
    box-sizing: border-box;
    position: relative;
}

.shan {
    position: absolute;
    right: 0;
    bottom: 0;
}

.bannerTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 38px;
}

.bannerText {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 25px;
}

.bannerline {
    width: 40px;
    height: 1px;
    background: #ffffff;
    margin-top: 20px;
    margin-bottom: 18px;
}

.bannerBtn {
    display: inline-block;
    width: 121px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    line-height: 32px;
    text-align: center;
}

.main {
    padding: 50px 0;
}

.mainCenter {
    margin: 0 50px;
}

.mainLeft {
    width: 200px;
}

.mainRight {
    width: 300px;
}

.newsList a {
    font-size: 18px;
}

.newsList p {
    line-height: 38px;
}

/* 左侧带背景菜单 */
.menuLitagWrap {
    list-style: none;
    margin: 0;
    padding: 0;
}

.menulitag {
    height: 110px;
}

.menulitag a {
    display: inline-block;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f1f2f4;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
}

.hoverimg {
    display: none;
}

.menulitag:last-child {
    border-bottom: none;
}

.menulitagActive a {
    background: url(/image/index/menulibg.png);
}

.menulitagActive a {
    color: #fff;
}

.menulitagActive .hoverimg {
    display: inline-block;
}

.menulitagActive .normalimg {
    display: none;
}

/* 右边列表设置 */
.custom_img {
    width: 67px;
    height: 66px;
    background: #0b8586;
    border: 1px solid #0b8586;
    border-radius: 7px 0px 7px 0px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.daynumber {
    font-size: 26px;
    font-weight: bold;
}

.datenumber {
    font-size: 12px;
    padding-top: 4px;
    border-top: 1px solid #fff;
}

/* 底部左部菜单 */
/* 左边菜单部分 */
.pubL_menu {
    list-style: none;
    margin: 0;
    padding: 0;
}

.pubL_menu li {
    position: relative;
}

.pubL_menu li a {
    display: inline-block;
    height: 46px;
    width: 200px;
    text-align: center;
    box-sizing: border-box;
    line-height: 46px;
}

.pubL_menu a {
    background-color: #e6f3f3;
}

.arrtig {
    position: absolute;
    width: 0;
    height: 0;
    border: solid 8px;
    border-color: transparent transparent transparent #0b8686;
    right: -16px;
    top: 14px;
    display: none;
}

.pubL_menu_active a {
    background: #0b8686;
    color: #fff;
}

.pubL_menu_active .arrtig {
    display: block;
}

.number {
    margin-top: 20px;
}

.number table {
    border-collapse: collapse;
    width: 100%;
    /* 	border: 1px solid #ddd; */
}

.number table td {
    border: 1px solid #dee2e6;
    height: 30px;
    text-align: center;
    cursor: pointer;
}

.number table td a {
    width: 100%;
    height: 100%;
    line-height: 30px;
    display: inline-block;
}

.activeTd {
    background-color: #0b8686;
    border: 1px solid #0b8686;
}

.activeTd a {
    color: #fff;
}

.ortextWrap {
    height: 495px;
    overflow: auto;
    width: 100%;
    font-size: 18px;
    font-family: Microsoft YaHei;
    color: #404040;
    margin-top: 32px;
}

.ortextWrap div {
    margin-left: 20px;
    margin-bottom: 16px;
}

/* 设置底部轮播  注意顺序 positionBtn*/
.positionBtn_swiper {
    margin-top: 20px;
    position: relative;
    width: 640px;
}

.nextbutton,
.prevbutton {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 42%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton {
    right: -30px;
    left: auto;
}

.prevbutton {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}

.setShow {
    display: none;
}

.controlShow:hover .setShow {
    display: flex;
}

.controlShow:hover .disShow {
    display: none;
}

.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}
</style>
